module.exports = __webpack_public_path__ + "static/apple-icon-152x152-51c8221230cca7a6ccd12533bf6c6b84.png";